/* ══ NTL CART MILESTONES ═══════════════════════════════════════════════════
   Behaviour for snippets/ntl-cart-milestones.liquid, on the cart page and in the
   drawer.

   WHY THIS IS A SEPARATE ASSET AND NOT INLINE
   The drawer's HTML is re-inserted with DOMParser + replaceWith, and scripts
   created that way never execute. A {% javascript %} block in the cart section
   evaluates once per page load and not on an AJAX swap either. So the code has to
   live outside the markup it drives and re-read the DOM on every cart event.

   WHAT SURVIVES A CART UPDATE
   Nothing in the DOM. Every mutation replaces the whole <cart-container> and, on
   the cart page, the whole section. Any "already celebrated" flag kept on a node is
   destroyed with it — so tier state lives in module scope and sessionStorage.

   THE CURRENCY CORRECTION
   Thresholds are written in the SHOP's currency; `cart.total_price` and every
   line price Liquid gives us are in the ACTIVE MARKET's. Liquid cannot convert, so
   the server renders the raw comparison (right in the shop's own market) and this
   re-does the arithmetic everywhere else:

       threshold_here = threshold_shop × Shopify.currency.rate

   Without it a "500" milestone unlocks at ¥500 for a shopper in Japan — about
   three dollars.
   ═══════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (window.__ntlMilestones) return;
  window.__ntlMilestones = true;

  var CONFETTI_SRC = null;              /* resolved from the DOM, see confettiSrc() */
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  var busyUntil = 0;                    /* auto add/remove cooldown, see reconcile */
  var lastAction = '';                  /* what the last auto action was, for dedupe */
  var lastTier = null;                  /* highest tier seen cleared, this page life */

  /* `typed`  the amount is taken at face value in whatever currency the shopper is
                browsing — 500 always reads as 500. What a merchant expects when they
                type 500, and the default.
     `shop`   the amount is in the SHOP's currency and converted, so the milestone is
                worth the same real money in every market. Mathematically right, but
                a 500 written for an AUD shop shows as $363.37 to a USD shopper, which
                reads as a bug to everyone who did not choose it. */
  function rate(root) {
    if (!root || root.getAttribute('data-ms-fx') !== 'shop') return 1;
    var r = window.Shopify && window.Shopify.currency && window.Shopify.currency.rate;
    var n = parseFloat(r);
    return isFinite(n) && n > 0 ? n : 1;
  }

  function money(cents) {
    if (window.NTL && NTL.money) return NTL.money(Math.round(cents));
    return (Math.round(cents) / 100).toFixed(2);
  }

  /* ── celebrated tiers ──────────────────────────────────────────────────────
     sessionStorage so a reload of an already-qualifying cart does not re-fire,
     but a new visit can celebrate again. Wrapped because Safari private mode
     throws on access, and a dead celebration must never break the cart. */
  function seen() {
    try { return JSON.parse(sessionStorage.getItem('ntl-ms-seen') || '[]') || []; }
    catch (e) { return []; }
  }
  function markSeen(list) {
    try { sessionStorage.setItem('ntl-ms-seen', JSON.stringify(list.slice(-20))); }
    catch (e) {}
  }
  /* A tier that is no longer cleared is forgotten, so crossing it AGAIN celebrates
     again. Keeping it for the whole session meant that once a shopper dipped below
     and came back — or a merchant simply tested it twice — nothing ever happened,
     and the feature looked broken while working exactly as written. */
  function forgetAbove(tier) {
    var keep = seen().filter(function (t) { return t <= tier; });
    markSeen(keep);
    return keep;
  }

  function confettiSrc(root) {
    if (CONFETTI_SRC) return CONFETTI_SRC;
    CONFETTI_SRC = root.getAttribute('data-ms-confetti-src') || '';
    return CONFETTI_SRC;
  }

  /* canvas-confetti is vendored but loaded by nothing, so it is fetched the first
     time a celebration is actually due rather than on every page that has a cart */
  function withConfetti(root, fn) {
    if (window.confetti) { fn(); return; }
    var src = confettiSrc(root);
    if (!src) return;
    if (document.querySelector('script[data-ntl-confetti]')) {
      /* already loading from an earlier burst — wait for it, but not forever */
      var tries = 0;
      var iv = setInterval(function () {
        if (window.confetti) { clearInterval(iv); fn(); }
        else if (++tries > 40) { clearInterval(iv); }
      }, 50);
      return;
    }
    var sc = document.createElement('script');
    sc.src = src;
    sc.defer = true;
    sc.setAttribute('data-ntl-confetti', '');
    sc.onload = function () { if (window.confetti) fn(); };
    document.head.appendChild(sc);
  }

  var BRAND = ['#5B6B2F', '#C9A227', '#E0765F', '#8FB3CF', '#EFE7D8'];

  function celebrate(root) {
    if (!root.hasAttribute('data-ms-confetti')) return;
    /* the global reduced-motion rule in ntl-base.css neutralises CSS animation but
       cannot touch a canvas — that is JS painting pixels — so gate it explicitly */
    if (reduced && reduced.matches) return;
    withConfetti(root, function () {
      if (!window.confetti) return;
      var box = root.getBoundingClientRect();
      /* aim at the bar itself; in the drawer that is the right-hand column, and a
         burst from the centre of the viewport would read as unrelated to it */
      var x = (box.left + box.width / 2) / Math.max(1, window.innerWidth);
      var y = (box.top + box.height * 0.8) / Math.max(1, window.innerHeight);
      x = Math.min(0.98, Math.max(0.02, x));
      y = Math.min(0.95, Math.max(0.05, y));

      function burst(opts) {
        try { window.confetti(opts); } catch (e) {}
      }
      var common = { colors: BRAND, origin: { x: x, y: y }, disableForReducedMotion: true };
      /* two angled bursts read as a party popper; one straight burst reads as a
         loading spinner that exploded */
      burst(Object.assign({}, common, {
        particleCount: 55, spread: 55, angle: 60, startVelocity: 38, scalar: 0.95, ticks: 160
      }));
      burst(Object.assign({}, common, {
        particleCount: 55, spread: 55, angle: 120, startVelocity: 38, scalar: 0.95, ticks: 160
      }));
      setTimeout(function () {
        burst(Object.assign({}, common, {
          particleCount: 30, spread: 90, startVelocity: 26, scalar: 0.8, ticks: 130, decay: 0.9
        }));
      }, 160);
    });
  }

  /* ── the one pass that reconciles a widget with the cart ────────────────── */
  function paint(root) {
    var r = rate(root);
    var spend = parseInt(root.getAttribute('data-ms-spend'), 10) || 0;
    var maxShop = parseInt(root.getAttribute('data-ms-max'), 10) || 0;
    if (maxShop <= 0) return null;

    var maxHere = maxShop * r;
    var pct = Math.max(0, Math.min(100, (spend / maxHere) * 100));

    var fill = root.querySelector('[data-ntl-ms-fill]');
    if (fill) fill.style.width = pct + '%';
    var track = root.querySelector('[data-ntl-ms-track]');
    /* floor, matching the Liquid: rounding 99.998 to 100 announces the reward as
       reached while it is still locked */
    if (track) track.setAttribute('aria-valuenow', String(Math.floor(pct)));

    var items = root.querySelectorAll('[data-ntl-ms-item]');
    var done = 0;
    var nextAmt = 0;
    var nextLab = '';
    var i;

    for (i = 0; i < items.length; i++) {
      var el = items[i];
      var shopAmt = parseInt(el.getAttribute('data-ntl-ms-item'), 10) || 0;
      var hereAmt = shopAmt * r;
      var got = spend >= hereAmt;
      el.classList.toggle('is-on', got);
      if (got) {
        done++;
      } else if (!nextAmt) {
        nextAmt = hereAmt;
        var lab = el.querySelector('.ntl-ms-rw');
        nextLab = lab ? lab.textContent.trim() : '';
      }
      /* the printed threshold has to move with the market too */
      if (r !== 1) {
        var amtEl = el.querySelector('[data-ntl-ms-amt]');
        if (amtEl) amtEl.textContent = money(hereAmt);
      }
    }

    var pins = root.querySelectorAll('[data-ntl-ms-pin]');
    for (i = 0; i < pins.length; i++) {
      var pAmt = (parseInt(pins[i].getAttribute('data-ntl-ms-pin'), 10) || 0) * r;
      pins[i].classList.toggle('is-on', spend >= pAmt);
      pins[i].style.left = Math.min(100, (pAmt / maxHere) * 100) + '%';
    }

    /* ── rebuild the HEADLINE, do not patch it ─────────────────────────────
       The server wrote that sentence from the unconverted threshold. Once the
       arithmetic is re-done for this market the verdict itself can change, and
       patching only the number left "$53.00 away" sitting beside a full bar and a
       row marked Added — the widget contradicting itself on screen. */
    var head = root.querySelector('.ntl-ms-head');
    if (head) {
      if (done === items.length && items.length > 0) {
        var allTpl = root.getAttribute('data-ms-tpl-all') || 'Every reward unlocked';
        if (head.textContent.trim() !== allTpl) {
          head.textContent = '';
          var b = document.createElement('b');
          b.textContent = allTpl;
          head.appendChild(b);
        }
      } else if (nextAmt) {
        var tpl = root.getAttribute('data-ms-tpl-toward') || '[amount] away from [reward]';
        var left = money(Math.max(0, nextAmt - spend));
        head.textContent = '';
        var parts = tpl.split('[amount]');
        var tail = (parts.length > 1 ? parts[1] : tpl).split('[reward]');
        if (parts.length > 1) head.appendChild(document.createTextNode(parts[0]));
        if (parts.length > 1) {
          var amtB = document.createElement('b');
          amtB.setAttribute('data-ntl-ms-togo', '');
          amtB.textContent = left;
          head.appendChild(amtB);
        }
        head.appendChild(document.createTextNode(tail[0]));
        if (tail.length > 1) {
          head.appendChild(document.createTextNode(nextLab));
          head.appendChild(document.createTextNode(tail[1]));
        }
      }
    }

    root.classList.toggle('is-on', done > 0);
    root.classList.toggle('is-max', done === items.length && items.length > 0);
    root.setAttribute('data-ms-done', String(done));

    return { done: done, total: items.length, items: items, spend: spend, rate: r };
  }

  /* ── auto mode ─────────────────────────────────────────────────────────────
     Adding a reward triggers a cart reload, which re-runs this — so without a
     guard it is an infinite loop by construction. Three things stop it: an
     in-flight flag, a check that the reward is not already a line, and only ever
     acting on ONE tier per pass. */
  function reconcile(root, state) {
    var auto = root.getAttribute('data-ms-mode') === 'auto';

    /* A TIME-BASED cooldown, not a plain in-flight flag. The flag would clear when
       the fetch resolves, but the cart DOM is swapped AFTER that — so the very next
       `kt.cart.reloaded` would read the old markup, still see the reward missing,
       and add it a second time. The cooldown outlives the swap.
       `lastAction` is the second guard: the same add is never issued twice in a row
       even if the cooldown has passed and the DOM is somehow still stale. */
    if (Date.now() < busyUntil) return;

    var i, el, act;

    /* ── TAKING A REWARD BACK HAPPENS IN BOTH MODES ────────────────────────
       This is not a preference, it is correctness. The reward was given on a
       condition; when the shopper drops below it the Shopify discount stops
       applying and the tote silently becomes a £69 line they did not choose to
       buy. The mode setting only decides whether the reward is ADDED for them. */
    for (i = 0; i < state.items.length; i++) {
      el = state.items[i];
      if (el.classList.contains('is-on')) continue;      /* still earned */
      if (!el.classList.contains('is-got')) continue;    /* not in the bag */
      var key = el.getAttribute('data-ms-line');
      if (!key) continue;                                /* not one of ours */
      act = 'del:' + key;
      if (act === lastAction) return;
      lastAction = act;
      busyUntil = Date.now() + 2500;
      var gone = el.querySelector('.ntl-ms-rw');
      removeLine(key, gone ? gone.textContent.trim() : '');
      return;
    }

    /* ── adding is the part the merchant chooses ───────────────────────────── */
    if (!auto) { lastAction = ''; return; }

    for (i = 0; i < state.items.length; i++) {
      el = state.items[i];
      if (!el.classList.contains('is-on')) continue;
      if (el.classList.contains('is-got')) continue;
      var form = el.querySelector('form.ntl-ms-add');
      if (!form) continue;                       /* no product, or sold out */
      act = 'add:' + el.getAttribute('data-ntl-ms-item');
      if (act === lastAction) return;
      lastAction = act;
      busyUntil = Date.now() + 2500;
      addReward(form);
      return;
    }

    /* nothing to do — clear the dedupe so a later, genuine repeat can happen */
    lastAction = '';
  }

  function routes() {
    var R = (window.Shopify && window.Shopify.routes) || {};
    return {
      add: (R.cart_add_url || '/cart/add') + '.js',
      change: (R.cart_change_url || '/cart/change') + '.js'
    };
  }

  function reload(data) {
    var c = document.querySelector('cart-container');
    if (c && c.reloadCartElements && data && data.sections) {
      c.reloadCartElements(data.sections);
    } else {
      window.dispatchEvent(new CustomEvent('kt.cart.reloaded'));
    }
  }

  function addReward(form) {
    var fd = new FormData(form);
    fd.append('sections', 'cart-count-badge,offcanvas-cart');
    fd.append('sections_url', window.location.pathname);
    return fetch(routes().add, { method: 'POST', headers: { Accept: 'application/json' }, body: fd })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(new Error('add')); })
      .then(function (d) { reload(d); })
      .catch(function () {
        /* a failed auto-add must not nag: the shopper did not ask for it, and the
           Add button is still there for them */
      });
  }

  function removeLine(key, label) {
    /* Say so. An item vanishing from the bag with no explanation reads as the shop
       losing the order, which is worse than the charge it prevents. */
    if (window.NTL && NTL.toast) {
      NTL.toast(label
        ? (label + ' removed — your bag is below the amount that earns it')
        : 'Reward removed — your bag is below the amount that earns it');
    }
    return fetch(routes().change, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: key, quantity: 0,
        sections: 'cart-count-badge,offcanvas-cart',
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(new Error('remove')); })
      .then(function (d) { reload(d); })
      .catch(function () {});
  }

  /* ── boot, and after every cart change ─────────────────────────────────── */
  function run() {
    var roots = document.querySelectorAll('[data-ntl-ms]');
    if (!roots.length) return;

    var best = null;
    for (var i = 0; i < roots.length; i++) {
      var st = paint(roots[i]);
      if (st && (!best || st.done > best.done)) best = { done: st.done, root: roots[i], st: st };
    }
    if (!best) return;

    /* EDGE-detect the tier. Testing "is it unlocked" instead would re-fire on every
       re-render, and the cart re-renders on every quantity change — and again for
       the drawer, which is a second copy of the same widget on the same page. */
    var tier = best.done;
    var already = seen();
    if (lastTier === null) lastTier = tier;

    /* dropped back down: forget the tiers above so re-earning them celebrates */
    if (tier < lastTier) already = forgetAbove(tier);

    if (tier > lastTier && tier > 0 && already.indexOf(tier) === -1) {
      already.push(tier);
      markSeen(already);
      celebrate(best.root);
      var live = best.root.querySelector('[data-ntl-ms-live]');
      if (live) {
        var row = best.root.querySelectorAll('[data-ntl-ms-item]')[tier - 1];
        var lab = row && row.querySelector('.ntl-ms-rw');
        live.textContent = lab ? ('Reward unlocked: ' + lab.textContent.trim()) : 'Reward unlocked';
      }
    }
    lastTier = tier;

    reconcile(best.root, best.st);
  }

  function boot() { try { run(); } catch (e) {} }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  /* both surfaces end their refresh with this event */
  window.addEventListener('kt.cart.reloaded', function () { setTimeout(boot, 0); });
  document.addEventListener('shopify:section:load', boot);
})();
